import { css } from '@emotion/react';
import { Box, List, ListItem, styled } from '@mui/joy';

import BWLogo from '@/assets/logos/baden-wuerttemberg-logo.svg?react';
import { RouterLink } from '@/components/router/RouterLink';
import { useIsBackend } from '@/hooks/useIsBackend';
import { NAVIGATION_ITEMS } from '@/modules/NAVIGATION_ITEMS';

const Root = styled(Box)(
  ({ theme }) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${theme.vars.palette.neutral['100']};
    margin-top: auto;
    z-index: 1100;
    padding-top: ${theme.spacing(2)};
    padding-bottom: ${theme.spacing(2)};
    flex-direction: column-reverse;

    ${theme.breakpoints.up('md')} {
      height: ${theme.spacing(7)};
      padding-top: 0;
      padding-bottom: 0;
      flex-direction: row;
    }
  `,
);

const StyledList = styled(List)(
  ({ theme }) => css`
    justify-content: flex-end;
    align-items: center;
    gap: ${theme.spacing(1)};
    flex-direction: column;

    ${theme.breakpoints.up('md')} {
      flex-direction: row;
    }
  `,
);

const StyledFooterLink = styled(RouterLink)(
  ({ theme }) => css`
    font-weight: bold;
    font-size: ${theme.vars.fontSize.sm};
    padding-inline: ${theme.spacing(1)};
    padding-block: ${theme.spacing(0.75)};
    border-radius: ${theme.vars.radius.sm};
  `,
) as typeof RouterLink;

export function Footer() {
  const { isBackend } = useIsBackend();

  return (
    <Root component="footer">
      {isBackend ? <BWLogo style={{ height: '40', width: 'auto', marginLeft: 10 }} /> : null}
      <StyledList orientation="horizontal" role="menubar">
        {(isBackend
          ? [{ title: 'Hilfe', to: '/verwaltung/hilfe' }, ...NAVIGATION_ITEMS.toSpliced(0, 1)]
          : NAVIGATION_ITEMS
        ).map(({ title, to }) => (
          <ListItem key={title} role="none">
            <StyledFooterLink color="neutral" role="menuitem" to={to} underline="none" variant="plain">
              {title}
            </StyledFooterLink>
          </ListItem>
        ))}
      </StyledList>
    </Root>
  );
}
